import { Button } from "antd";
import dayjs from "dayjs";
import { useParams } from "react-router";
import { useVerifyCertificateQuery } from "../../../app/features/courses/courses.api";
import DownloadIcon from "../../../assets/icons/DownloadIcon";
import { ENV_CONFIG } from "../../../config/global.config";
import useDownloadPdf from "../../../hooks/useDownloadPdf";
import CertificateV2 from "../../user/courseModule/_components/CertificateV2";

export default function PublicCertificate() {
  const { certificateNo } = useParams();
  const { data: courseDetails } = useVerifyCertificateQuery(
    {
      certificateNo: certificateNo!,
    },
    {
      skip: !certificateNo,
    }
  );
  // Download certificate hook
  const { pdfRef, isDownloading, downloadPdf } = useDownloadPdf();

  const shareLink = `${ENV_CONFIG.FRONTEND_URL}/verify-certificate/${certificateNo}`;

  const handleDownload = () => {
    const courseName = courseDetails?.courseTitle || "Course";
    const fileName = `${courseName}_Certificate`;

    downloadPdf({ fileName, title: "সার্টিফিকেট" });
  };

  return (
    <div className="p-10 relative">
      <Button
        variant="outlined"
        type="primary"
        icon={<DownloadIcon />}
        onClick={handleDownload}
        loading={isDownloading}
        size="small"
        className="absolute right-5 top-5 !bg-white !border-theme-zinc-200/50 !text-black z-10"
      />
      <div className="max-w-[990px] overflow-x-auto mx-auto">
        <div className="bg-white shadow-md opacity-0 absolute">
          <div ref={pdfRef} className="w-[990px]">
            <CertificateV2
              qrCode={shareLink}
              courseName={courseDetails?.courseTitle}
              issueDate={courseDetails?.certificateIssueDate}
              name={courseDetails?.userName}
              passportNumber={courseDetails?.userPassportNo}
            />
          </div>
        </div>
      </div>

      <div className="max-w-[990px] overflow-x-auto mx-auto">
        <div className="bg-white shadow-md">
          <div className="w-[990px]">
            <CertificateV2
              qrCode={shareLink}
              courseName={courseDetails?.courseTitle}
              issueDate={
                courseDetails?.certificateIssueDate
                  ? dayjs(courseDetails?.certificateIssueDate).format(
                      "MMMM DD, YYYY"
                    )
                  : undefined
              }
              name={courseDetails?.userName}
              passportNumber={courseDetails?.userPassportNo}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
